<template>
	<div class="home" :style="{ '--content-width': contentWidth.includes('px') ? contentWidth : contentWidth + 'px' }">
		<!-- 顶部广告图 -->
		<img v-for="(ad, idx) in topAdList" :key="idx" :src="ad.image_url" class="top_ad_img" @click="handleAdClick(ad.link_url)">
		<!-- 轮播图 -->
		<div class="banner_container">
			<img :src="topBannerList[currentIndex]?.image_url" class="banner_img" :class="{ 'fade-out': isTransitioning }" @click="handleBannerClick(topBannerList[currentIndex])">
			<img v-if="isTransitioning" :src="topBannerList[nextIndex]?.image_url" class="banner_img fade-in">
			<div class="navigation_module content_width">
				<div class="navigation_left">
					<div v-for="(item,index) in navigationLeft" :key="item.nav" class="navigation_item "
						@mouseenter="enterNavigation(item)" @mouseleave="leaveNavigation(item)">
						<svg class="icon_svg" aria-hidden="true">
							<use :xlink:href="item.icon"></use>
						</svg>
						{{item.text}}
					</div>
				</div>
				<div class="navigation_middle" v-show="showMoreNavigation" @mouseenter="enterMoreNav" @mouseleave="leaveMoreNav">
					<div v-for="(item,index) in activeNav" :key="item.nav" class="navigation_item" @click="toNavigation(item)">
						{{item.text}}
					</div>
				</div>
				<div class="navigation_right" @click="handleBannerClick(topBannerList[currentIndex])"></div>
				<div class="bannerCard">
					<div v-for="(item,index) in bannerCardList" :key="index" class="card"
						:class="currentIndex2 == index?'active':''" @click="changeBanner(index)"
						:style="{ pointerEvents: isTransitioning ? 'none' : 'auto' }">
						<img :src="item">
					</div>
				</div>
			</div>
		</div>



		<!-- 公告栏 -->
		<div class="notice_container ">
			<div class="notice_content content_width">
				<div class="left">
					<svg class="icon_svg" aria-hidden="true">
						<use :xlink:href="'#icon-gonggao'"></use>
					</svg>
					<div class="title">
						网站公告:
					</div>
					<div class="content">
						<div class="notice_item" :style="{ transform: `translateY(${noticeOffset}px)` }" @click="toArticle('notice',noticeList[noticeIndex].id)">
							{{noticeList[noticeIndex]?.text || ''}}
						</div>
						<div v-if="isNoticeScrolling" class="notice_item next-item"
							:style="{ transform: `translateY(${nextOffset}px)` }">
							{{noticeList[nextNoticeIndex]?.text || ''}}
						</div>
					</div>
				</div>
				<div class="more">查看更多</div>
			</div>
		</div>

		<div class="module_container content_width">
			<div class="module_1 ">
				<div class="banner-wrapper">
					<img v-for="(item, index) in bannerList" :key="index" :src="item"
						:class="{ 'active': index === currentBannerIndex, 'fade-out': index === prevBannerIndex }">
				</div>
				<div class="pager">
					<div class="item" v-for="(item, index) in bannerList" :key="index"
						:class="{'active': index === currentBannerIndex}" @mouseenter="handlePagerHover(index)"
						@mouseleave="handlePagerLeave">{{ index+1 }}</div>
				</div>
			</div>
			<div class="module_2 ">
				<div class="head_content">
					<div class="left">
						<svg class="icon_svg" aria-hidden="true">
							<use :xlink:href="'#icon-dongtai'"></use>
						</svg>
						<div class="title">医考动态</div>
					</div>
					<div class="right font_size_12">查看更多</div>
				</div>
				<div class="content">
					<div v-for="(item, index) in medicalExamination" :key="item.id" class="item">
						<div class="title"><span class="point"></span><span class="text">{{item.title}}</span></div>
						<div class="time font_size_12">{{item.time}}</div>
					</div>
				</div>
			</div>
			<div class="module_3 ">
				<div class="head_content">
					<div class="left">
						<svg class="icon_svg" aria-hidden="true">
							<use :xlink:href="'#icon-zhuxiukecheng'"></use>
						</svg>
						<div class="title">成绩查询</div>
					</div>
					<div class="right font_size_12">查看更多</div>
				</div>
				<div class="content">
					<div v-for="(item, index) in gradeInquiry" :key="item.id" class="item">
						<div class="title"><span class="point"></span><span class="text">{{item.title}}</span></div>
						<div class="time font_size_12">{{item.time}}</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 分类信息栏 -->
		<ClassifyComponent v-for="section in classifySections" :key="section.slug || section.title"
			:sectionData="section" />

		<img :src="homeBannerBg1" class="banner_img content_width" @click="toNavigation({nav:'appDownload'})">
		<img :src="homeBannerBg2" class="banner_img content_width" @click="toNavigation({nav:'chineseMedicine'})">
		<img :src="homeBannerBg3" class="banner_img content_width">

		<div class="functional_module content_width">
			<div class="head">
				<img src="@/assets/home/functional_bg.png" alt="">
				<div class="box">
					<div>
						<svg class="icon_svg" aria-hidden="true">
							<use :xlink:href="'#icon-bofang'"></use>
						</svg>
						<div>视频课程免费试听</div>
					</div>
					<div class="more" @click="toNavigation({nav:'videoCourse'})">
						查看更多
					</div>
				</div>
			</div>
			<div class="video_content">
				<div v-for="(item, index) in videoList" :key="item.id" class="item" @click="toNavigation({nav:'videoCourse'})">
					<img :src="item.img" alt="">
					<div class="text">
						{{item.text}}
					</div>
				</div>
			</div>
		</div>

		<div class="functional_module content_width">
			<div class="head">
				<img src="@/assets/home/functional_bg.png" alt="">
				<div class="box">
					<div>
						<svg class="icon_svg" aria-hidden="true">
							<use :xlink:href="'#icon-mianshoujiaoxueanpai'"></use>
						</svg>
						<div>面授培训</div>
					</div>
					<div class="more">
						查看更多
					</div>
				</div>
			</div>
			<div class="video_content">
				<div v-for="(item, index) in locationList" :key="item.id" class="item location_item">
					<img :src="item.img" class="img">
					<div class="text2">{{item.text1}}</div>
					<div class="text2">{{item.text2}}</div>
					<div class="text2">{{item.text3}}</div>
				</div>
				<div class="more_item">
					查看更多
				</div>
			</div>
		</div>

		<img src="@/assets/home/teacher.jpg" class="teacher_img content_width">

		<div class="doctor_container content_width">
			<div class="swiper-container ">
				<!-- 轮播内容 -->
				<div class="swiper-wrapper">
					<div class="swiper-slide swiper-no-swiping" v-for="(item, index) in swiperList" :key="item.id">
						<div class="swiper_main">
							<img :src="item.img" class="avatar" />
							<div class="name">{{item.name}}</div>
							<div class="des">{{item.des}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="button_prev " @click="swiper_move('prev')">
				<svg class="icon_svg" aria-hidden="true">
					<use :xlink:href="'#icon-xiangzuo'"></use>
				</svg>
			</div>
			<div class="button_next " @click="swiper_move('next')">
				<svg class="icon_svg" aria-hidden="true">
					<use :xlink:href="'#icon-xiangyou1'"></use>
				</svg>
			</div>
		</div>

		<div class="promotion_container ">
			<div class="content_width">
				<div class="top_img">
					<img src="@/assets/home/promotion_top_l.png">
					<img src="@/assets/home/promotion_top_r.png">
				</div>
				<div class="promotion_code">
					<div class="code_main">
						<div class="cdoe"><img :src="qrCode1Image"></div>
						<div class="qr_label">{{ qrCode1Text }}</div>
					</div>
					<div class="code_main">
						<div class="cdoe"><img :src="qrCode2Image"></div>
						<div class="qr_label">{{ qrCode2Text }}</div>
					</div>
					<img :src="qrSplitImage" class="split">
					<div class="code_main">
						<div class="cdoe"><img :src="qrCode3Image"></div>
						<div class="qr_label">{{ qrCode3Text }}</div>
					</div>
					<div class="code_main">
						<div class="cdoe"><img :src="qrCode4Image"></div>
						<div class="qr_label">{{ qrCode4Text }}</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import ClassifyComponent from '@/views/home/components/classify.vue'
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'
	import { getBanners, getNotices, getArticles, getVideos, getLocations, getExperts, getSiteConfigs, getCategories, getChannelCategories } from '@/api'

	export default {
		name: 'HomeView',
		components: {
			ClassifyComponent,
		},
		data() {
			return {
				topBannerList: [],
			showBanner: 1,
				currentIndex: 0,
				currentIndex2: 0,
				nextIndex: 1,
				isTransitioning: false,
				bannerTime: null,
				resumeTimer: null,
				showMoreNavigation: false,
				showMoreNavigationTime: null,
				activeNav:[],
				bannerCardList: [],
				navigationLeft: [],
				moreNavigation: {},

				noticeList: [],
				noticeIndex: 0,
				nextNoticeIndex: 1,
				noticeTimer: null,
				isNoticeScrolling: false,
				noticeOffset: 0,
				nextOffset: 24,
				bannerList: [],
				currentBannerIndex: 0,
				prevBannerIndex: -1,
				bannerTimer: null,
				isBannerTransitioning: false,

				medicalExamination: [],
				gradeInquiry: [],
				classifySections: [],
				contentWidth: '1200px',
				videoList: [],
				locationList: [],
				swiper: null,
				swiperList: [],
				// 推广二维码配置
				qrCode1Image: '',
				qrCode1Text: '',
				qrCode2Image: '',
				qrCode2Text: '',
				qrSplitImage: '',
				qrCode3Image: '',
				qrCode3Text: '',
				qrCode4Image: '',
				qrCode4Text: '',

				// 横幅广告图
				homeBannerBg1: '',
				homeBannerBg2: '',
				homeBannerBg3: '',

				// 顶部广告列表（从banners API加载，静态备份）
				topAdList: [],
			}
		},

		mounted() {
			this.fetchData()
			this.startNoticeScroll();
			this.startBannerScroll();
			// 3. DOM 渲染完成后初始化 swiper
			this.swiper = new Swiper('.swiper-container', {
				// 基础配置
				loop: true, // 循环轮播
				autoplay: false, // 自动播放
				speed: 1000, // 切换速度
				slidesPerView: 4,
				spaceBetween: 20,
				breakpointsBase: 'container',
				noSwiping: true,
			})

			this.bannerTime = setInterval(() => {
				this.nextIndex = (this.currentIndex + 1) % 4;
				this.isTransitioning = true;
				this.currentIndex2 = this.nextIndex;
				setTimeout(() => {
					this.currentIndex = this.nextIndex;
					this.isTransitioning = false;
				}, 1000);
			}, 5000);
		},
		beforeDestroy() {
			clearInterval(this.bannerTimer);
			clearInterval(this.noticeTimer);
		},
		methods: {
			async fetchData() {
				try {
					// 顶部轮播图
					const banners = await getBanners({ position: 'home_top' })
					if (banners && banners.length) {
						this.topBannerList = banners.map(b => ({ image_url: b.image_url, link_url: b.link_url || '' }))
						this.bannerCardList = banners.map(b => b.image_url)
					}
				} catch (e) { console.log('API未连接') }

				try {
					// 中部轮播广告
					const midBanners = await getBanners({ position: 'home_mid' })
					if (midBanners && midBanners.length) {
						this.bannerList = midBanners.map(b => b.image_url)
					}
				} catch (e) { console.log('API未连接') }

				try {
					// 首页顶部广告（动态可增删）
					const topAdBanners = await getBanners({ position: 'home_top_ad' })
					if (topAdBanners && topAdBanners.length) {
						this.topAdList = topAdBanners.map(b => ({ image_url: b.image_url, link_url: b.link_url || '' }))
					}
				} catch (e) { console.log('API未连接') }

				try {
					// 公告
					const notices = await getNotices()
					if (notices && notices.length) {
						this.noticeList = notices.map(n => ({ text: n.title, id: n.id }))
					}
				} catch (e) { console.log('API未连接') }

				try {
					// 医考动态文章
					const articles = await getArticles({ page: 1, page_size: 10 })
					if (articles && articles.items && articles.items.length) {
						this.medicalExamination = articles.items.map(a => ({
							title: a.title, time: (a.published_at || '').slice(5, 10), id: a.id
						}))
					}
				} catch (e) { console.log('API未连接') }

				try {
					// 成绩查询文章
					const gradeArticles = await getArticles({ page: 1, page_size: 10, status: 1 })
					if (gradeArticles && gradeArticles.items && gradeArticles.items.length) {
						this.gradeInquiry = gradeArticles.items.map(a => ({
							title: a.title, time: (a.published_at || '').slice(5, 10), id: a.id
						}))
					}
				} catch (e) { console.log('API未连接') }

				try {
					// 视频
					const videos = await getVideos()
					if (videos && videos.length) {
						this.videoList = videos.slice(0, 4).map(v => ({
							img: v.poster_url, text: v.title, id: v.id
						}))
					}
				} catch (e) { console.log('API未连接') }

				try {
					// 面授地点
					const locations = await getLocations()
					if (locations && locations.length) {
						this.locationList = locations.map(l => ({
							img: l.image_url, text1: l.city, text2: l.phone, text3: l.address, id: l.id
						}))
					}
				} catch (e) { console.log('API未连接') }

				try {
					// 专家
					const experts = await getExperts()
					if (experts && experts.length) {
						this.swiperList = experts.map(e => ({
							img: e.avatar_url, name: e.name, des: e.description || e.specialty, id: e.id
						}))
					}
				} catch (e) { console.log('API未连接') }
				
				// 专家数据加载完成后，更新 swiper
				if (this.swiper) {
					this.$nextTick(() => this.swiper.update())
				}
				
				try {
					// 分类导航 - 从API获取
					const cats = await getCategories()
					if (cats && cats.length) {
						const parents = cats.filter(c => !c.parent_id)
						const children = cats.filter(c => c.parent_id)
						if (parents.length) {
							this.navigationLeft = parents.map(c => ({
								text: c.name, nav: c.slug || c.name, icon: c.icon || '#icon-zigezheng'
							}))
							const moreNav = {}
							parents.forEach(p => {
								const subs = children.filter(c => c.parent_id === p.id)
								if (subs.length) {
									moreNav[p.slug || p.name] = subs.map(c => ({
										text: c.name, nav: c.slug || c.name
									}))
								}
							})
							if (Object.keys(moreNav).length) this.moreNavigation = moreNav
						}
					}
				} catch (e) { console.log('分类导航数据加载失败') }
				
				try {
					// 首页分类模块 - 动态加载
					const parentCats = await getCategories({ parent_only: true })
					if (parentCats && parentCats.length) {
						const sections = []
						for (const parent of parentCats) {
							try {
								const childCats = await getChannelCategories({ parent_slug: parent.slug })
								sections.push({
									title: parent.name,
									icon: parent.icon || '#icon-zigezheng',
									image_url: parent.image_url || '',
									slug: parent.slug,
									children: (childCats || []).map(c => ({
										name: c.name,
										slug: c.slug,
										image_url: c.image_url || '',
										articles: c.articles || [],
									})),
								})
							} catch (e2) {
								console.log(`分类[${parent.name}]子分类加载失败`)
							}
						}
						// 过滤掉没有子分类的父级（如现场面授、APP题库等独立分类）
						const validSections = sections.filter(s => s.children && s.children.length)
						this.classifySections = validSections.length ? validSections : this.buildClassifyFallback()
					} else {
						this.classifySections = this.buildClassifyFallback()
					}
				} catch (e) {
					console.log('分类模块数据加载失败，使用静态回退数据')
					this.classifySections = this.buildClassifyFallback()
				}

				try {
					// 推广二维码配置
					const configs = await getSiteConfigs()
					if (configs) {
						if (configs.home_qr_1_image) this.qrCode1Image = configs.home_qr_1_image
						if (configs.home_qr_1_text) this.qrCode1Text = configs.home_qr_1_text
						if (configs.home_qr_2_image) this.qrCode2Image = configs.home_qr_2_image
						if (configs.home_qr_2_text) this.qrCode2Text = configs.home_qr_2_text
						if (configs.home_qr_3_image) this.qrCode3Image = configs.home_qr_3_image
						if (configs.home_qr_3_text) this.qrCode3Text = configs.home_qr_3_text
						if (configs.home_qr_4_image) this.qrCode4Image = configs.home_qr_4_image
						if (configs.home_qr_4_text) this.qrCode4Text = configs.home_qr_4_text
						if (configs.home_content_width) this.contentWidth = configs.home_content_width
					if (configs.home_banner_bg_1) this.homeBannerBg1 = configs.home_banner_bg_1
					if (configs.home_banner_bg_2) this.homeBannerBg2 = configs.home_banner_bg_2
					if (configs.home_banner_bg_3) this.homeBannerBg3 = configs.home_banner_bg_3
					}
				} catch (e) { console.log('API未连接') }
			},
			toArticle(type,id) {
				this.$router.push({
					path: '/article',
					query: {
						type: type,
						id: id,
					}
				});
			},
			toNavigation(item) {
				this.$router.push({
					path: item.nav,
				});
			},
			handleBannerClick(banner) {
				if (!banner || !banner.link_url) return
				if (banner.link_url.startsWith('http://') || banner.link_url.startsWith('https://')) {
					window.open(banner.link_url, '_blank')
				} else {
					this.$router.push(banner.link_url)
				}
			},
			handleAdClick(link) {
				if (!link) return
				if (link.startsWith('http://') || link.startsWith('https://')) {
					window.open(link, '_blank')
				} else {
					this.$router.push(link)
				}
			},
			enterNavigation(item) {
				clearTimeout(this.showMoreNavigationTime);
				this.showMoreNavigation = true;
				this.activeNav = this.moreNavigation[item.nav] || [];
			},
			leaveNavigation(item) {
				this.showMoreNavigationTime = setTimeout(() => {
					this.showMoreNavigation = false;
				}, 100);
			},
			enterMoreNav() {
				clearTimeout(this.showMoreNavigationTime);
			},
			leaveMoreNav(item) {
				this.showMoreNavigationTime = setTimeout(() => {
					this.showMoreNavigation = false;
				}, 100);
			},
			changeBanner(index) {
				clearInterval(this.bannerTime);
				clearTimeout(this.resumeTimer);
				this.nextIndex = index;
				this.isTransitioning = true;
				this.currentIndex2 = index;
				setTimeout(() => {
					this.currentIndex = index;
					this.isTransitioning = false;
				}, 1000);
				this.resumeTimer = setTimeout(() => {
					this.bannerTime = setInterval(() => {
						this.nextIndex = (this.currentIndex + 1) % 4;
						this.isTransitioning = true;
						this.currentIndex2 = this.nextIndex;
						setTimeout(() => {
							this.currentIndex = this.nextIndex;
							this.isTransitioning = false;
						}, 1000);
					}, 5000);
				}, 5000);
			},


			swiper_move(direction) {
				if (direction === 'prev') {
					this.swiper.slidePrev();
				} else if (direction === 'next') {
					this.swiper.slideNext();
				}
			},
			startNoticeScroll() {
				this.noticeTimer = setInterval(() => {
					this.isNoticeScrolling = true;
					this.nextNoticeIndex = (this.noticeIndex + 1) % this.noticeList.length;
					this.nextOffset = 24;

					const startTime = Date.now();
					const duration = 500;
					const animate = () => {
						const elapsed = Date.now() - startTime;
						const progress = Math.min(elapsed / duration, 1);

						this.noticeOffset = -progress * 24;
						this.nextOffset = 24 - progress * 24;

						if (progress < 1) {
							requestAnimationFrame(animate);
						} else {
							this.noticeIndex = this.nextNoticeIndex;
							this.noticeOffset = 0;
							this.isNoticeScrolling = false;
						}
					};
					requestAnimationFrame(animate);
				}, 3000);
			},
			startBannerScroll() {
				this.bannerTimer = setInterval(() => {
					if (!this.isBannerTransitioning) {
						this.prevBannerIndex = this.currentBannerIndex;
						this.currentBannerIndex = (this.currentBannerIndex + 1) % this.bannerList.length;
						this.isBannerTransitioning = true;
						setTimeout(() => {
							this.isBannerTransitioning = false;
							this.prevBannerIndex = -1;
						}, 500);
					}
				}, 2500);
			},
			handlePagerHover(index) {
				if (!this.isBannerTransitioning && index !== this.currentBannerIndex) {
					clearInterval(this.bannerTimer);
					this.prevBannerIndex = this.currentBannerIndex;
					this.currentBannerIndex = index;
					this.isBannerTransitioning = true;
					setTimeout(() => {
						this.isBannerTransitioning = false;
						this.prevBannerIndex = -1;
					}, 500);
				}
			},
			handlePagerLeave() {
				if (!this.isBannerTransitioning) {
					this.bannerTimer = setInterval(() => {
						this.prevBannerIndex = this.currentBannerIndex;
						this.currentBannerIndex = (this.currentBannerIndex + 1) % this.bannerList.length;
						this.isBannerTransitioning = true;
						setTimeout(() => {
							this.isBannerTransitioning = false;
							this.prevBannerIndex = -1;
						}, 500);
					}, 2500);
				}
			},
			buildClassifyFallback() {
				return [
					{
						title: '执业资格',
						icon: '#icon-zigezheng',
						image_url: 'https://oss.21yyh.com/assets/home/classify_1.jpg',
						slug: 'pract-qualification',
						children: [
							{ name: '护士资格', slug: 'nurse-qualification', image_url: 'https://oss.21yyh.com/assets/home/classify/1_1.jpg', articles: [
															{ title: '报名仅剩最后2天！广东 2025 年度高级卫生专业技术资格考试报名2月26日截止', published_at: '2025-02-28', id: 7 },
															{ title: '黑龙江 2025 年卫生高级职称考试安排来了', published_at: '2025-03-08', id: 8 },
															{ title: '一篇搞懂！2025年卫生资格考试人机考试规则！', published_at: '2025-04-11', id: 9 },
															{ title: '2025护士执业资格考试干货 | 护考牢记之专业知识', published_at: '2025-04-21', id: 10 },
							] },
							{ name: '中西医助理医师', slug: 'chinese-herbal-assistant', image_url: 'https://oss.21yyh.com/assets/home/classify/1_2.jpg', articles: [
								{ title: '护士考生必看，2025年护士考试都考什么题型？', published_at: '2025-04-22', id: 11 },
								{ title: '2025年护考时间及各阶段必做事宜！', published_at: '2025-04-28', id: 12 },
							] },
							{ name: '临床医师', slug: 'clinical-doctor', image_url: 'https://oss.21yyh.com/assets/home/classify/1_3.jpg', articles: [
								{ title: '2026 年卫生高级职称考试全攻略（考试概况 + 报名时间汇总）', published_at: '2026-01-15', id: 1 },
								{ title: '2026 卫生高级职称考试时间公布！你的省份报名了吗？', published_at: '2026-01-20', id: 2 },
							] },
							{ name: '乡村全科', slug: 'general-practitioner', image_url: 'https://oss.21yyh.com/assets/home/classify/1_4.jpg', articles: [
								{ title: '卫生高级职称考试问答（一）', published_at: '2026-02-01', id: 3 },
								{ title: '职称新规！2025年卫生高级职称评审政策大调整', published_at: '2025-06-10', id: 4 },
							] },
							{ name: '临床助理医师', slug: 'clinical-assistant-doctor', image_url: 'https://oss.21yyh.com/assets/home/classify/1_5.jpg', articles: [
								{ title: '重磅消息！医考或将全面改革大变！', published_at: '2025-08-15', id: 5 },
								{ title: '2025年中西医执业医师笔试官方教材', published_at: '2025-03-20', id: 6 },
							] },
							{ name: '执业西药师', slug: 'pharmacist', image_url: 'https://oss.21yyh.com/assets/home/classify/1_6.jpg', articles: [
								{ title: '速记！初级护师考试知识点1-100', published_at: '2025-02-28', id: 13 },
								{ title: '7个小窍门，助你备考2025初级护师考试', published_at: '2025-03-08', id: 14 },
							] },
							{ name: '中医医师', slug: 'doctor-of-chinese', image_url: 'https://oss.21yyh.com/assets/home/classify/1_7.jpg', articles: [
								{ title: '2026 年卫生高级职称考试全攻略（考试概况 + 报名时间汇总）', published_at: '2026-01-15', id: 1 },
								{ title: '职称新规！2025年卫生高级职称评审政策大调整', published_at: '2025-06-10', id: 4 },
								{ title: '2025年中西医执业医师笔试官方教材', published_at: '2025-03-20', id: 6 },
							] },
							{ name: '公卫医师', slug: 'public-health-doctor', image_url: 'https://oss.21yyh.com/assets/home/classify/1_8.jpg', articles: [
								{ title: '2026 卫生高级职称考试时间公布！你的省份报名了吗？', published_at: '2026-01-20', id: 2 },
								{ title: '重磅消息！医考或将全面改革大变！', published_at: '2025-08-15', id: 5 },
							] },
							{ name: '中医助理医师', slug: 'chinese-assistant-doctor', image_url: 'https://oss.21yyh.com/assets/home/classify/1_9.jpg', articles: [
								{ title: '报名仅剩最后2天！广东 2025 年度高级卫生专业技术资格考试报名2月26日截止', published_at: '2025-02-28', id: 7 },
								{ title: '黑龙江 2025 年卫生高级职称考试安排来了', published_at: '2025-03-08', id: 8 },
							] },
							{ name: '口腔医师', slug: 'dentist', image_url: 'https://oss.21yyh.com/assets/home/classify/1_10.jpg', articles: [
								{ title: '一篇搞懂！2025年卫生资格考试人机考试规则！', published_at: '2025-04-11', id: 9 },
								{ title: '2025护士执业资格考试干货 | 护考牢记之专业知识', published_at: '2025-04-21', id: 10 },
							] },
							{ name: '中西医医师', slug: 'doctor-of-chinese-and-herbal', image_url: 'https://oss.21yyh.com/assets/home/classify/1_11.jpg', articles: [
								{ title: '护士考生必看，2025年护士考试都考什么题型？', published_at: '2025-04-22', id: 11 },
								{ title: '2025年护考时间及各阶段必做事宜！', published_at: '2025-04-28', id: 12 },
							] },
							{ name: '口腔助理医师', slug: 'dentist-assistant', image_url: 'https://oss.21yyh.com/assets/home/classify/1_12.jpg', articles: [
								{ title: '速记！初级护师考试知识点1-100', published_at: '2025-02-28', id: 13 },
								{ title: '7个小窍门，助你备考2025初级护师考试', published_at: '2025-03-08', id: 14 },
							] },
						],
					},
					{
						title: '卫生职称',
						icon: '#icon-weishengjiancha',
						image_url: 'https://oss.21yyh.com/assets/home/classify_2.jpg',
						slug: 'health-title',
						children: [
							{ name: '初级护师', slug: 'primary-nurse', image_url: 'https://oss.21yyh.com/assets/home/classify/2_1.jpg', articles: [
								{ title: '速记！初级护师考试知识点1-100', published_at: '2025-02-28', id: 13 },
								{ title: '7个小窍门，助你备考2025初级护师考试', published_at: '2025-03-08', id: 14 },
							] },
							{ name: '主管护师', slug: 'supervisor-nurse', image_url: 'https://oss.21yyh.com/assets/home/classify/2_2.jpg', articles: [
								{ title: '职称新规！2025年卫生高级职称评审政策大调整', published_at: '2025-06-10', id: 4 },
								{ title: '2026 年卫生高级职称考试全攻略（考试概况 + 报名时间汇总）', published_at: '2026-01-15', id: 1 },
							] },
						],
					},
					{
						title: '技师职称',
						icon: '#icon-zhuanjiazhicheng',
						image_url: 'https://oss.21yyh.com/assets/home/classify_3.jpg',
						slug: 'technician-title',
						children: [
							{ name: '康复医学治疗技术', slug: 'rehabilitation-tech', image_url: 'https://oss.21yyh.com/assets/home/classify/3_1.jpg', articles: [
								{ title: '2026 卫生高级职称考试时间公布！你的省份报名了吗？', published_at: '2026-01-20', id: 2 },
								{ title: '卫生高级职称考试问答（一）', published_at: '2026-02-01', id: 3 },
							] },
							{ name: '医学检验技术', slug: 'lab-tech', image_url: 'https://oss.21yyh.com/assets/home/classify/3_2.jpg', articles: [
								{ title: '重磅消息！医考或将全面改革大变！', published_at: '2025-08-15', id: 5 },
								{ title: '2025年中西医执业医师笔试官方教材', published_at: '2025-03-20', id: 6 },
							] },
						],
					},
					{
						title: '三基考试',
						icon: '#icon-tikuliebiao',
						image_url: 'https://oss.21yyh.com/assets/home/classify_4.jpg',
						slug: 'three-base-exam',
						children: [
							{ name: '医学临床三基', slug: 'clinical-three-base', image_url: 'https://oss.21yyh.com/assets/home/classify/4_1.jpg', articles: [
								{ title: '2025护士执业资格考试干货 | 护考牢记之专业知识', published_at: '2025-04-21', id: 10 },
								{ title: '护士考生必看，2025年护士考试都考什么题型？', published_at: '2025-04-22', id: 11 },
							] },
							{ name: '护理三基', slug: 'nursing-three-base', image_url: 'https://oss.21yyh.com/assets/home/classify/4_2.jpg', articles: [
								{ title: '2025年护考时间及各阶段必做事宜！', published_at: '2025-04-28', id: 12 },
								{ title: '一篇搞懂！2025年卫生资格考试人机考试规则！', published_at: '2025-04-11', id: 9 },
							] },
						],
					},
				]
			}
		}
	}
</script>
<style scoped lang="scss">
	.home {
		font-size: 16px;
	}

	.top_ad_img {
		width: 100%;
		display: block;
		cursor: pointer;
	}

	.banner_container {
		width: 100%;
		height: 300px;
		position: relative;
		overflow: hidden;
		.banner_img {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			opacity: 1;
		}
		.fade-out {
			opacity: 0;
			transition: opacity 1s ease;
		}
		.fade-in {
			opacity: 0;
			animation: fadeIn 1s ease forwards;
		}
		.navigation_module {
			position: absolute;
			top: 0%;
			height: 100%;
			left: 50%;
			transform: translateX(-50%);
			display: flex;

			.navigation_left {
				height: 100%;
				background-color: rgba(0, 0, 0, 0.5);
				width: 210px;
				color: #fff;

				.navigation_item {
					padding-left: 20px;
					cursor: pointer;
					text-align: left;
					font-size: 15px;
					display: flex;
					align-items: center;
					height: 16.6%;

					.icon_svg {
						margin-right: 10px;
						font-size: 11px;
					}
				}

				.navigation_item:hover {
					background-color: #4DA1EC;
				}
			}

			.navigation_middle {
				height: 100%;
				width: 500px;
				background-color: rgba(255, 255, 255, 0.9);
				display: flex;
				flex-wrap: wrap;
				align-content: flex-start;
				position: relative;
				z-index: 1;

				.navigation_item {
					margin-left: 20px;
					margin-top: 20px;
					cursor: pointer;
					text-align: left;
					font-size: 13px;
				}
			}
			.navigation_right{
				width: calc(100% - 210px);
				height: 100%;
				position: absolute;
				top: 0%;
				right: 0;
				display: flex;
				cursor: pointer;
			}

			.bannerCard {
				position: absolute;
				top: 0%;
				right: 0;
				z-index: 1;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				padding: 15px 0;

				.card {
					cursor: pointer;
					height: 22%;
					border: 3px solid #fff;

					img {
						height: 100%;
					}
				}

				.active {
					border-color: #4DA1EC;
				}
			}

		}
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	.notice_container {
		width: 100%;
		background-color: #fff;
		padding: 10px 0;
		font-size: 14px;

		.notice_content {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 10px;

			.left {
				display: flex;
				align-items: center;

				.icon_svg {
					font-size: 12px;
				}

				.title {
					margin: 0 10px;
					height: 24px;
				}

				.content {
					height: 24px;
					overflow: hidden;
					position: relative;
					width: 500px;
					text-align: left;
					cursor: pointer;

					.notice_item {
						line-height: 24px;
						height: 24px;
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
					}

					.next-item {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
					}
				}
			}

			.more {
				color: #999;
				cursor: pointer;
			}
		}
	}

	.module_container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 20px auto 10px;

		.module_1,
		.module_2,
		.module_3 {
			width: 32%;
			background-color: #fff;
			height: 410px;

			.head_content {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10px;
				border-bottom: 1px solid #E5E5E5;

				.left {
					display: flex;
					align-items: center;

					.icon_svg {
						font-size: 12px;
					}

					.title {
						margin-left: 5px;
						font-size: 16px;
						font-weight: 900;
					}
				}

				.right {
					color: #999;
					cursor: pointer;
				}
			}

			.content {
				padding: 10px;
				font-size: 15px;

				.item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					height: 35px;

					.title {
						display: flex;
						align-items: center;
						width: 75%;
						cursor: pointer;

						.point {
							display: inline-block;
							width: 1px;
							height: 1px;
							background-color: #000;
							border-radius: 50%;
							margin-right: 5px;
						}

						.text {
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
							overflow: hidden;
						}
					}
				}
			}
		}

		.module_1 {
			position: relative;
			padding: 10px;

			.banner-wrapper {
				position: relative;
				width: 100%;
				height: 100%;

				img {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					opacity: 0;
					transition: opacity 0.5s ease;

					&.active {
						opacity: 1;
					}

					&.fade-out {
						opacity: 0;
					}
				}
			}

			.pager {
				position: absolute;
				top: 20px;
				left: 20px;
				display: flex;
				align-items: center;

				.item {
					margin-right: 5px;
					cursor: pointer;
					background-color: rgba(0, 0, 0, 0.2);
					text-align: center;
					width: 20px;
					height: 20px;
					line-height: 20px;
					font-size: 12px;
				}

				.active {
					background-color: #fff;
				}
			}
		}
	}

	.banner_img {
		margin: 0px auto 20px;
		cursor: pointer;
	}

	.functional_module {
		.head {
			position: relative;
			color: #fff;

			>img {
				width: 100%;
			}

			.box {
				position: absolute;
				top: 0%;
				left: 0%;
				width: 100%;
				height: 100%;
				padding: 0 20px;
				display: flex;
				align-items: center;
				justify-content: space-between;

				>div {
					display: flex;
					align-items: center;

					.icon_svg {
						margin-right: 10px;
					}
				}
				.more {
					font-size: 14px;
					cursor: pointer;
				}
			}
		}

		.video_content {
			margin: 10px auto 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;

			.item {
				width: 24%;
				background-color: #fff;
				cursor: pointer;

				>img {
					width: 100%;
				}

				.text {
					font-size: 14px;
					padding: 20px 20px 40px;
					text-align: left;
				}

			}

			.location_item {
				width: 19%;
				margin-bottom: 10px;
				height: 200px;

				.img {
					width: 82px;
					border: 1px solid #90C6F6;
					margin: 20px auto 10px;
				}

				.text2 {
					font-size: 14px;
					margin-bottom: 1px;
					text-align: center;
				}
			}

			.more_item {
				width: 19%;
				height: 200px;
				line-height: 200px;
				text-align: center;
				background-color: #fff;
				cursor: pointer;
				font-size: 24px;
				color: #999;
				margin-bottom: 10px;
			}
		}
	}

	.teacher_img {
		margin: 0 auto 10px;
	}

	.doctor_container {
		margin: 0 auto 40px;
		position: relative;
		height: 320px;

		.button_prev,
		.button_next {
			width: 50px;
			height: 50px;
			background-color: #388ad4;
			border-radius: 5px;
			font-size: 17px;
			color: #fff;
			font-weight: 900;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.button_prev {
			left: 0;
		}

		.button_next {
			right: 0;
		}
	}

	.swiper-container {
		height: 320px;
		width: 85%;

		.swiper_main {
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding: 40px 20px;
			background-color: #fff;

			.avatar {
				width: 80px;
				height: 80px;
				border-radius: 50%;
				margin: 0 auto 30px;
			}

			.name {
				font-weight: 600;
				margin-bottom: 10px;
				font-size: 15px;
			}

			.des {
				font-size: 14px;
				color: #999;
			}
		}
	}

	.promotion_container {
		background-color: #fff;

		>.content_width {
			position: relative;
			padding: 70px 0 25px;

			.top_img {
				position: absolute;
				top: -15px;
				left: 0;
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;

				>img {
					margin: 0 20px;
				}
			}

			.promotion_code {
				display: flex;
				justify-content: center;
				align-items: center;

				.code_main {
					display: flex;
					justify-content: center;
					flex-wrap: wrap;
					width: 150px;
					margin: 0 20px;

					.cdoe {
						width: 150px;
						height: 150px;
						background-size: 100% 100%;
						padding: 10px;
						background-image: url('@/assets/home/code_bg.jpg');

						>img {
							width: 100%;
						}
					}

					.qr_label {
						margin-top: 15px;
						width: 100%;
						text-align: center;
						font-size: 14px;
						color: #333;
						line-height: 1.4;
						white-space: nowrap;
					}
				}

				.split {
					margin: 0 70px;
				}
			}
		}
	}
</style>ng: 70px 0 25px;

			.top_img {
				position: absolute;
				top: -15px;
				left: 0;
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;

				>img {
					margin: 0 20px;
				}
			}

			.promotion_code {
				display: flex;
				justify-content: center;
				align-items: center;

				.code_main {
					display: flex;
					justify-content: center;
					flex-wrap: wrap;
					width: 150px;
					margin: 0 20px;

					.cdoe {
						width: 150px;
						height: 150px;
						background-size: 100% 100%;
						padding: 10px;
						background-image: url('@/assets/home/code_bg.jpg');

						>img {
							width: 100%;
						}
					}

					.qr_label {
						margin-top: 15px;
						width: 100%;
						text-align: center;
						font-size: 14px;
						color: #333;
						line-height: 1.4;
						white-space: nowrap;
					}
				}

				.split {
					margin: 0 70px;
				}
			}
		}
	}
</style>